import { render, staticRenderFns } from "./AppContactlessDelivery.vue?vue&type=template&id=371a29b4"
import script from "./AppContactlessDelivery.vue?vue&type=script&lang=js"
export * from "./AppContactlessDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports